import { render, staticRenderFns } from "./UnitManagement.vue?vue&type=template&id=45f5b7a6&scoped=true"
import script from "./UnitManagement.vue?vue&type=script&lang=js"
export * from "./UnitManagement.vue?vue&type=script&lang=js"
import style0 from "./UnitManagement.vue?vue&type=style&index=0&id=45f5b7a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f5b7a6",
  null
  
)

export default component.exports